import { IconName } from "@fortawesome/fontawesome-svg-core";
import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { SubmenuItem } from "Components/Core/Sidebar/subMenus";
import i18n, { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { CoreStore } from "Stores/RESTStore/CoreStore";
import { MAIL_LINK } from "../Communication";
import { emailUnreadStore } from "./EmailUnreadStore";

interface MenuItemWithBadgeProps extends WithTranslation {
  prop?: string;
  label: string;
  store?: CoreStore;
  icon?: IconName;
}

type SubMenus =
  | "INBOX"
  | "SENT"
  | "ARCHIVE"
  | "LINKED"
  | "INBOX_PROJECT"
  | "SENT_PROJECT"
  | "TOPIC_INBOX"
  | "DRAFTS"
  | "ARCHIVE_PROJECT";

const MenuItemWithBadge = withTranslation("project")(
  observer((props: MenuItemWithBadgeProps) => {
    return (
      <div className="menu-with-badge">
        {props.t(props.label)} {props.store[props.prop] ? <span>{props.store[props.prop]}</span> : ""}
      </div>
    );
  })
);

const MenuItem = withTranslation("project")(({ label, t }: { label: string } & WithTranslation) => <>{t(label)}</>);

export const mailsSubMenu = {
  get linkedMailToolTipText() {
    return (
      <span>
        <>
          {i18n.t("Use the ", { ns: I18N_NS.PROJECT }) as string}
          <strong>{i18n.t('"Link with project..." action ', { ns: I18N_NS.PROJECT }) as string}</strong>
          {i18n.t("to move files here and to share them with the project", { ns: I18N_NS.PROJECT })}
        </>
      </span>
    );
  },
  get config(): SubmenuItem[] {
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "MAIL")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;
    const links: SubmenuItem[] = [
      {
        label: <MenuItemWithBadge label={`Inbox`} store={emailUnreadStore} prop={"unreadPrivate"} />,
        link: MAIL_LINK.INBOX,
      },
      {
        label: <MenuItem label={"Sent"} />,
        link: MAIL_LINK.SENT,
      },
      {
        label: <MenuItem label={"Linked"} />,
        link: MAIL_LINK.LINKED,
        message: this.linkedMailToolTipText,
      },
      {
        label: <MenuItem label={"Archived"} />,
        link: MAIL_LINK.ARCHIVED,
      },
    ];

    if (subModules) {
      subModules.includes("INBOX_PROJECT") &&
        links.push({
          label: <MenuItemWithBadge label={`Inbox (Project)`} store={emailUnreadStore} prop={"unreadProject"} />,
          link: MAIL_LINK.INBOX_PROJECT,
        });
      subModules.includes("SENT_PROJECT") &&
        links.push({
          label: <MenuItem label={"Sent (Project)"} />,
          link: MAIL_LINK.SENT_PROJECT,
        });
      subModules.includes("TOPIC_INBOX") &&
        links.push({
          label: <MenuItem label={"Topic inbox"} />,
          link: MAIL_LINK.TOPIC_INBOX,
        });
      subModules.includes("ARCHIVE_PROJECT") &&
        links.push({
          label: <MenuItem label={"Archived (Project)"} />,
          link: MAIL_LINK.ARCHIVE_PROJECT,
        });
      subModules.includes("DRAFTS") &&
        links.push({
          label: <MenuItem label={"Drafts"} />,
          link: MAIL_LINK.DRAFT,
        });
    }
    return links;
  },
};
